module.exports = __webpack_public_path__ + "static/media/wifiqube-4.a887ec5d.jpg";